import React from 'react';
const Overview = () => <div className="p-8"><h1 className="text-2xl font-bold">Overview Page</h1></div>;
export default Overview; 